<!-- Inline SVG instead of Lucide/Svgo: Lucide only exposes the whole component, not its inner elements. We need to animate just the needle (the polygon), so the SVG is written by hand. -->
<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
    />
    <polygon
      points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
      class="origin-center animate-compass-needle"
    />
  </svg>
</template>
